module.exports = __webpack_public_path__ + "img/appAsset-flag--MX.fc0d1bd9.svg";